<template>
  <div class="form">
    <div class="header">
      <h1 v-html="$t('unbounce.poster.headline')" />
      <p>
        Don't
        <span class="b">give</span> your data to Big Tech firms,
        <span class="b">rent</span> it out to advertisers and make them pay you for it.
      </p>
      <p class="b">Mobile registration is now available!</p>
    </div>

    <div class="column">
      <sign-up-form id="sign-up" />
    </div>
  </div>
</template>

<script>
import SignUpForm from '@/views/ab/SignUpForm.vue';

export default {
  components: {
    SignUpForm,
  },
  provide() {
    return {
      theme: {
        mode: 'label',
        submitButtonText: this.$t('join.us.today'),
      },
    };
  },
};
</script>



<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@200;600&family=Roboto:wght@100&display=swap');
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';

.form {
  min-height: 100vh;
  overflow: hidden;
  text-align: center;
  background: rgba(58, 101, 240, 0.8);
  background: -webkit-linear-gradient(
      rgba(58, 101, 240, 0.8),
      rgba(58, 101, 240, 0.8)
    ),
    url('~@/assets/icons/m1.jpg') no-repeat;
  background-position: center;
  background-size: cover;

  * {
    font-family: 'Nunito', sans-serif;
  }

  .b {
    font-weight: bold;
  }

  h1 {
    margin-top: 5vh !important;
    font-size: 2.4em;
    font-weight: bold;
  }

  p {
    font-size: 1em;
  }

  h1,
  p {
    color: white;
    margin: 20px 10px;
  }
}
</style>

<style lang="scss">
#sign-up {
  background-color: transparent;

  form {
    h1 {
      display: none;
    }
    .privacy {
      span,
      a {
        color: white;
      }

      a {
        text-decoration: underline;
      }
    }

    .security-item {
      background-color: white;
    }

    .security-lvl-1,
    .security-lvl-2,
    .security-lvl-3 {
      background-color: orange;
    }

    .security-lvl-1-text,
    .security-lvl-2-text,
    .security-lvl-3-text {
      color: orange;
      font-weight: bold;
    }

    button[type='submit'] {
      height: 60px;
      font-size: 22px;
      font-weight: bold;
      margin-top: 10px;
    }

    button[type='submit']:not(:disabled) {
      background-color: orange;
      span {
        color: white;
      }
    }

    button[type='submit']:disabled {
      background-color: orange;
      span {
        color: white;
      }
      opacity: 0.7;
    }

    .password-rules,
    .separator {
      color: white;
    }

    .password-container {
      width: 100%;
    }

    .password-rules {
      display: none;
    }

    .password-inputs {
      display: flex;
      flex-direction: row;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: orange;
      border-color: orange;
    }

    .has-error .ant-form-explain,
    .has-error .ant-form-split {
      color: orange !important;
      font-weight: bold;
      text-align: left;
    }

    .has-error .ant-input-affix-wrapper .ant-input,
    .has-error .ant-input-affix-wrapper .ant-input:hover {
      border-color: orange !important;
    }

    .has-error .ant-input,
    .has-error .ant-input:hover {
      border-color: orange !important;
    }

    .input-label {
      color: white;
      font-weight: bold;
      line-height: 20px;
    }

    .full-name-container {
      display: flex;
      flex-direction: row;
    }
  }
}
</style>